import { Tool } from "@app/tool/model/tool.model";
import { ValueUnit } from "@models/enums/value-unit.enum";

export class TicketOperationTool {

    public id: number;
    public tool: Tool;
    public valueUnit: ValueUnit;
    public productionValue: number;
    public plannedRevision: number;
    public percentage: number;
    public canBeReturned: boolean;

    static get type() {
        return 'ticket-operation-recurrences';
    }

    constructor(ticketOperationTool: any = {}) {
        if (!ticketOperationTool) {
            return new TicketOperationTool();
        }
        this.id = ticketOperationTool.id || 0;
        this.tool = new Tool(ticketOperationTool.tool);
        this.valueUnit = ticketOperationTool.valueUnit;
        this.productionValue = ticketOperationTool.productionValue || null;
        this.plannedRevision = ticketOperationTool.plannedRevision || null;
        this.percentage = ticketOperationTool.percentage || null;
        this.canBeReturned = ticketOperationTool.canBeReturned || false;
    }
}
